import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 mixin
const CustomSwal = withReactContent(Swal);

export default CustomSwal;
